<template>
  <el-drawer
    title="预览"
    :visible.sync="drawerVisible"
    direction="rtl"
    size="600px"
    custom-class="preview-drawer"
    @close="$emit('close')"
  >
    <div class="content">
      <el-scrollbar :native="false">
        <div class="detail-box" v-loading="loading">
          <img :src="data.cigarUrl" class="pic" />
          <div class="detail-content">
            <div class="name-box">
              <div class="name">{{data.cigarName}}</div>
              <div class="name-eg">{{data.cigarEnglishName}}</div>
            </div>
            <div class="middle-box">
              <div class="cell">
                <div class="cell-block flex-l">
                  强度：
                  <img
                    src="~assets/images/goods/star2.png"
                    v-for="(item,index) in data.cigarStrength"
                    :key="index"
                    class="star"
                  />
                </div>
                <div class="cell-block flex-l">
                  <span class="txt1">形状：</span>
                  <span class="txt2">{{data.cigarShape}}</span>
                </div>
              </div>
              <div class="cell">
                <div class="cell-block flex-l">
                  <span class="txt1">环：</span>
                  <span class="txt2">{{data.cigarRing }}</span>
                </div>
                <div class="cell-block flex-l">
                  <span class="txt1">长：</span>
                  <span class="txt2">{{data.cigarLong}}</span>
                </div>
              </div>
              <div class="cell-name">口味</div>
              <div class="cell-content">{{data.cigarFlavor }}</div>
              <div class="cell-name">详情描述</div>
              <div
                class="cell-content"
              >{{data.cigarDetail? data.cigarDetail : '暂无介绍' }}</div>
            </div>
            <div class="bottom-box">
              <div class="cell-name">店铺地址</div>
              <div
                class="shop-box"
                v-for="(item,index) in shopList"
                :key="index"
              >
                <span>{{item.shopName}}</span>
                <span decode="true" class="look-detail">查看详情 &gt;</span>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </el-drawer>
</template>

<script>
import { getCigar, getShopList } from '@/api/goods';

export default {
  name: 'cigarPage',
  data() {
    return {
      data: {},
      shopList: [],
      drawerVisible: false,
      loading: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    visible(value) {
      this.drawerVisible = value;
    },
    selectId(value) {
      this.handleShow(value);
    },
  },
  methods: {
    getCigar(id) {
      return getCigar(id).then((res) => {
        if (res.success) {
          this.data = res.data;
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getShopList() {
      return getShopList().then((res) => {
        if (res.success) {
          this.shopList = res.data;
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    async handleShow(id) {
      this.loading = true;
      await this.getCigar(id).catch(() => {});
      await this.getShopList().catch(() => {});
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "~assets/css/h5.styl";
.star
  width 20px
  height 20px
.cell
  display flex
  margin-top 10px
.cell-block
  display flex
  flex 1
  align-items center
</style>
